import React from "react"
import classNames from "classnames"

interface Props {
	title?: string
	children: React.ReactNode
	className?: string
	backgroundClassName?: string
	withShadow?: boolean
}

export function ReadyToLaunchCard({title, children, className, backgroundClassName, withShadow}: Props) {
	return (
		<div className={classNames("ready-to-launch-card", className, withShadow && "with-shadow")}>
			{backgroundClassName && <div className={classNames("ready-to-launch-card-bg-base", backgroundClassName)} />}
			{title && <h2 className="ready-to-launch-card-title">{title}</h2>}
			{children}
		</div>
	)
}
